
import { Row, Col, Alert, Modal } from "react-bootstrap";
import "containers/common/List.css";
import "react-datepicker/dist/react-datepicker.css";
import { default as React, useMemo } from "react";
import { PacmanLoader } from "react-spinners";
import { GenericTable } from "components/GenericTable";
import EditableCell from "containers/common/EditableCell";
import "containers/common/Table.css";
import { createElementIdFactory, createReusableTableElementIds } from "utils/elementIds";
import { PAGE_SIZES } from "utils/pageSizeConfig";
import { createColumnHelper } from "@tanstack/react-table";

const columnHelper = createColumnHelper();

function AppendixTotals({
    data,
    isLoading = false,
    isAuthenticated,
    saveRecord = async () => {},
    deleteRecord = () => {},
    updateTableState = () => {},
    controlType = "table",
    showAlert = false,
    errorMessage = "",
    onDismissAlert = () => {},
}) {
    const dataSet = "appendix_totals";
    const appendixIdPrefix = "appendix-list";
    const tableData = data || [];

    const createId = useMemo(
        () => createElementIdFactory(appendixIdPrefix),
        [appendixIdPrefix]
    );

    const tableElementIds = useMemo(
        () => createReusableTableElementIds(createId),
        [createId]
    );

    const columns = [
        columnHelper.accessor("appendix", {
            id: "appendix",
            header: "Appendix",
            style: { whiteSpace: "unset" },
        }),
        columnHelper.accessor("issue_date", {
            id: "issue_date",
            header: "Issue Date",
            cell: EditableCell,
            style: { textAlign: "center" },
        }),
        columnHelper.accessor("group", {
            id: "group",
            header: "Group",
            cell: EditableCell,
            style: { textAlign: "center" },
        }),
    ];

    if (!tableData) {
        return null;
    }

    return (
        <div className="AppendixSection">
            {isAuthenticated ? (
                <div className="appendix_totals">
                    <Modal show={showAlert} onHide={onDismissAlert} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Uh Oh!</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Alert variant="danger">{errorMessage}</Alert>
                        </Modal.Body>
                    </Modal>

                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                            {isLoading ? (
                                <div className="outer-div">
                                    <div className="sweet-loading inner-div">
                                        <PacmanLoader
                                            cssOverride={{ display: "block", margin: "0 auto" }}
                                            size={20}
                                            color="#e03c31"
                                            loading={isLoading}
                                        />
                                    </div>
                                </div>
                            ) : controlType === "table" ? (
                                <div className="custom-data-table">
                                    <GenericTable
                                        columns={columns}
                                        data={tableData}
                                        section={appendixIdPrefix}
                                        elementIds={tableElementIds}
                                        pageSize={PAGE_SIZES.newsLetter}
                                        enablePagination={true}
                                        enableSortingRemoval={false}
                                        meta={{
                                            updateData: (rowIndex, columnId, value) => {
                                                updateTableState(rowIndex, columnId, value);
                                            },
                                            handleSave: async ({ row, column, value }) => {
                                                const record = { ...row.original, [column.id]: value };
                                                try {
                                                    await saveRecord(dataSet, record);
                                                } catch (err) {
                                                    console.error("Save failed:", err);
                                                    return false;
                                                }
                                            },
                                            handleDelete: ({ row }) => {
                                                deleteRecord(dataSet, row.original);
                                            },
                                        }}
                                    />
                                </div>
                            ) : (
                                ""
                            )}
                        </Col>
                    </Row>
                </div>
            ) : null}
        </div>
    );
}

export default AppendixTotals;